//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "the_MOS_item_short_from_health_survey",
  data() {
    return {
      form: {
        value1: "",
        value2: "",
        value3: "",
        value4: "",
        value5: "",
        value6: "",
        value7: "",
        value8: "",
        value9: "",
        value10: "",
        value11: "",
        value12: "",
        value13: "",
        value14: "",
        value15: "",
        value16: "",
        value17: "",
        value18: "",
        value19: "",
        value20: "",
        value21: "",
        value22: "",
        value23: "",
        value24: "",
        value25: "",
        value26: "",
        value27: "",
        value28: "",
        value29: "",
        value30: "",
        value31: "",
        value32: "",
        value33: "",
        value34: "",
        value35: "",
      },
      hasScore: false,
      disabled: false,
      dataList: [
        { value: "5", name: "非常好" },
        { value: "4", name: "很好" },
        { value: "3", name: "好" },
        { value: "2", name: "一般" },
        { value: "1", name: "差" },
      ],
      dataList1: [
        { value: "5", name: "比1年前好很多" },
        { value: "4", name: "比1年前好一些" },
        { value: "3", name: "跟1年前差不多" },
        { value: "2", name: "比1年前差一些" },
        { value: "1", name: "比1年前差很多" },
      ],
      dataList2: [
        { value: "1", name: "限制很大" },
        { value: "2", name: "有些限制" },
        { value: "3", name: "毫无限制" },
      ],
      dataList3: [
      { value: "1", name: "是" },
      { value: "2", name: "不是" },
      ],
      dataList4: [
        { value: "5", name: "完全没有影响" },
        { value: "4", name: "有一点影响" },
        { value: "3", name: "中等影响" },
        { value: "2", name: "影响很大" },
        { value: "1", name: "影响非常大" },
      ],
      dataList5: [
        { value: "6", name: "完全没有疼痛" },
        { value: "5.4", name: "稍微有一点疼痛" },
        { value: "4.2", name: "有一点影响" },
        { value: "3.1", name: "中等疼痛" },
        { value: "2.2", name: "严重疼痛" },
        { value: "1", name: "很严重疼痛" },
      ],
      dataList6: [
        { value: "6", name: "完全没有影响" },
        { value: "4.75", name: "有一点影响" },
        { value: "3.5", name: "中等影响" },
        { value: "2.25", name: "影响很大" },
        { value: "1", name: "影响非常大" },
      ],
      dataList7: [
        { value: "5", name: "完全没有影响" },
        { value: "4", name: "有一点影响" },
        { value: "3", name: "中等影响" },
        { value: "2", name: "影响很大" },
        { value: "1", name: "影响非常大" },
      ],
      dataList8: [
        { value: "6", name: "所有的时间" },
        { value: "5", name: "大部分时间" },
        { value: "4", name: "比较多时间" },
        { value: "3", name: "一部分时间" },
        { value: "2", name: "小部分时间" },
        { value: "1", name: "没有这种感觉" },
      ],
      dataList9: [
        { value: "1", name: "所有的时间" },
        { value: "2", name: "大部分时间" },
        { value: "3", name: "比较多时间" },
        { value: "4", name: "一部分时间" },
        { value: "5", name: "小部分时间" },
        { value: "6", name: "没有这种感觉" },
      ],
      dataList10: [
        { value: "1", name: "绝对正确" },
        { value: "2", name: "大部分正确" },
        { value: "3", name: "不能肯定" },
        { value: "4", name: "大部分错误" },
        { value: "5", name: "绝对错误" },
      ],
      dataList11: [
        { value: "5", name: "绝对正确" },
        { value: "4", name: "大部分正确" },
        { value: "3", name: "不能肯定" },
        { value: "2", name: "大部分错误" },
        { value: "1", name: "绝对错误" },
      ],


      
     
      
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      let result = 0;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
        result += Number(form[key]);
      }
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        let physiology = form.value3 + form.value4 + form.value5 + form.value6 + form.value7 +form.value8 + form.value9 + form.value10 + form.value11 + form.value12
        let physiologicalFunctions = form.value13 + form.value14 + form.value15 + form.value16
        let bodyPain = form.value20 + form.value21
        let sumHealth = form.value1 + form.value32 + form.value33 + form.value34 + form.value35
        let energy = form.value22 + form.value26 + form.value28 + form.value30
        let socialFunction = form.value20 + form.value31
        let emotionalFunction = form.value17 + form.value18 + form.value19
        let  MentalHealth = form.value23 + form.value24 + form.value25 + form.value27 + form.value29

        self.hasScore = true;
        return {
          physiology,
          physiologicalFunctions,
          bodyPain,
          sumHealth,
          energy,
          socialFunction,
          emotionalFunction,
          MentalHealth,
          result
        };
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/the_MOS_item_short_from_health_survey.vue